// extracted by mini-css-extract-plugin
export var bodySections = "_dz-8";
export var gray = "_dz-7";
export var green = "_dz-4";
export var iconContainer = "_dz-9";
export var iconWidgetContainer = "_dz-1";
export var phoneIcon = "_dz-2";
export var red = "_dz-5";
export var statusDot = "_dz-3";
export var widgetContainer = "_dz-0";
export var yellow = "_dz-6";